import { AsyncPipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { IHtmlProxyTileDefinition } from '../../../interfaces/tiles/definitions/html-proxy-tile-definition.interface';

@Component({
  standalone: true,
  selector: 'html-proxy-tile',
  imports: [AsyncPipe],
  template: `<div [innerHTML]="content() | async"></div>`,
})
export class HtmlProxyTile {
  protected readonly tileInstance = input.required<IHtmlProxyTileDefinition>();

  protected readonly content = computed<Promise<string>>(() => {
    const { url } = this.tileInstance();

    if (url) {
      return fetch(url).then((response) => response.text());
    }
  });
}
